import "./unternehmen.css";
import React, { useState } from 'react';

import gesamt from "../../img/organigram_2.png";
import verpflegung from "../../img/organigram_1.png";
import ur from "../../img/organigram_3.png";

export default function Unternehmen()
 {  

    return    (
    <div id="wrapper" >
      <div style={{textAlign: 'center', margin: '10px' }}><span style={{textAlign: 'center', padding: '5px', background: 'white'}}>Zum vergößern bitte auf das Bild klicken - es öffnet sich in einem neuen Fenster</span></div>
      <div style={{height:"100%", textAlign: 'center'}}>
      
      <a target="_blank" href="https://intranet-backend.procuratio.com/nc/Intranet/Organigramme/organigram_gesamt.png"><img src="https://intranet-backend.procuratio.com/nc/Intranet/Organigramme/organigram_gesamt.png" style={{height:"100%",padding:"10px",width:"auto"}} alt="Unternehmen" /></a>
      </div>


    </div>

    )

 }


